import { render } from "./Percent.vue?vue&type=template&id=6f9564c4&scoped=true"
import script from "./Percent.vue?vue&type=script&lang=js"
export * from "./Percent.vue?vue&type=script&lang=js"

import "./Percent.vue?vue&type=style&index=0&id=6f9564c4&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9564c4"]])

export default __exports__